<!-- sidebar controls -->
<div #controlsWrapper class="sidebar-controls-wrapper" [class.active]="active">
  <div [title]="'Sidebar toggle'" class="control-btn" (click)="onToggleSidebar()">
    <i class="material-symbols-outlined more-icon">more_horiz</i>
  </div>

  <ng-container *ngIf="showFullscreenBtn">
    <div class="splitter"></div>
    <div [title]="fullScreenBtnTitle" class="control-btn" (click)="onFullScreenClicked($event)">
      <i #fullscreenIcon class="material-symbols-outlined fullscreen-icon">fullscreen</i>
    </div>
  </ng-container>

  <ng-container *ngIf="showMapViewsBtn">
    <div class="splitter"></div>
    <app-venue-maps-toggle-button *ngIf="venueMapsEnabled"
      [toggleState]="venueMapsVisible"
      [map]="map"
      [venueMaps]="venueMaps"
      [groundOverlays]="groundOverlays"
      [tileOverlays]="tileOverlays"
      (onButtonStateChanged)="onVenueMapsButtonStateChanged($event)"
    ></app-venue-maps-toggle-button>
  </ng-container>

  <ng-container *ngIf="showZonesAreasBtn">
    <div class="splitter"></div>
    <app-zone-area-toggle-button
      [map]="map"
      (onButtonStateChanged)="onZonesAreasButtonStateChanged($event)"
    ></app-zone-area-toggle-button>
  </ng-container>

  <ng-container *ngIf="showTrafficLayerBtn">
    <div class="splitter"></div>
    <app-traffic-layer-button
      class="control-btn"
      [map]="map">
    </app-traffic-layer-button>
  </ng-container>

  <ng-container *ngIf="showMyLocationBtn">
    <div class="splitter"></div>
    <div class="control-btn">
      <app-my-location-button
        (locationAvailableEvent)="onMyLocationAvailable($event)">
      </app-my-location-button>
    </div>
  </ng-container>

  <ng-container *ngIf="showW3WGridBtn">
    <div class="splitter"></div>
    <div class="control-btn">
      <app-w3w-grid-button [map]="map"></app-w3w-grid-button>
    </div>
  </ng-container>

  <ng-container *ngIf="showReloadBtn">
    <div class="splitter"></div>
    <div [title]="'Refresh/pan out'" class="control-btn" (click)="onRefreshClicked($event)">
      <i #refreshIcon class="material-symbols-outlined refresh-icon">refresh</i>
    </div>
  </ng-container>
</div>

<!-- expanded sidebar -->
<div #sidebarWrapper class="sidebar-wrapper">
  <!-- sidebar header -->
  <div class="header">
    <h3>{{T.common.map_options | translate}}</h3>
    <div class="dismiss" (click)="onCloseSidebar()">
      <i class="material-symbols-outlined">close</i>
    </div>
  </div>
  <!-- sidebar body -->
  <div class="body">
    <!-- map views section -->
    <div class="section-wrapper">
      <h5>{{T.common.show_all_areas | translate}}</h5>
      <app-map-views-group-button
        #mapTypesGroupButton
        [map]="map"
        (mapViewUnitSelected)="onMapViewUnitSelected($event)"
      ></app-map-views-group-button>
      <app-checkbox-with-label *ngIf="displayHybridMapCheckbox"
        class="hybrid-view"
        label="Display labels and additional overlays"
        intialState="unchecked"
        (clicked)="onHybridMapTypeClicked($event)"
      >
      </app-checkbox-with-label>
    </div>
    <!-- map levels section -->
    <div class="section-wrapper">
      <h5>{{T.common.map_levels | translate}}</h5>
      <app-checkbox-with-label
          class="all-levels"
          label="Show All Levels"
          [intialState]="visibleMapLayers.length ? 'unchecked': 'checked'"
          [disabled]="!visibleMapLayers.length"
          (clicked)="onMapLayerCheckStatusChanged(null, $event)"
        ></app-checkbox-with-label>
      <p class="explain">
        {{T.common.or_select_levels_bellow | translate}}
      </p>
      <ng-container *ngFor="let layer of mapLayers">
        <app-checkbox-with-label
          class="map-levels"
          label="Level {{ layer.label }}"
          [intialState]="mapLevelCheckState(layer) ? 'checked' : 'unchecked'"
          (clicked)="onMapLayerCheckStatusChanged(layer, $event)"
        ></app-checkbox-with-label>
      </ng-container>
    </div>
    <!-- zones, areas and venue maps section -->
    <div class="section-wrapper">
      <h5>{{localisedZones}}, {{localisedAreas}} & {{ T.common.venue_maps | translate }}</h5>
      <div class="controls-wrapper">
        <app-checkbox-with-label
          label="{{T.common.show_all_zones | translate}}"
          intialState="{{zonesVisible ? 'checked' : 'unchecked'}}"
          (clicked)="onZonesDisplayButtonStateChanged($event)"
        ></app-checkbox-with-label>
        <app-checkbox-with-label
          label="{{T.common.show_all_areas | translate}}"
          intialState="{{areasVisible ? 'checked' : 'unchecked'}}"
          (clicked)="onAreasDisplayButtonStateChanged($event)"
        ></app-checkbox-with-label>
        <app-checkbox-with-label
          label="{{T.common.show_all_venue_maps | translate}}"
          intialState="{{venueMapsVisible ? 'checked' : 'unchecked'}}"
          (clicked)="onVenueMapsDisplayButtonStateChanged($event)"
        ></app-checkbox-with-label>
      </div>
    </div>
  </div>
</div>
